(() => {
  'use strict';

  const root = document.querySelector('[data-seal-member-campaign]');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';

  const backdrop = root.querySelector('[data-campaign-backdrop]');
  const dialog = root.querySelector('[role="dialog"]');
  const closeButton = root.querySelector('[data-campaign-close]');
  const storageKey = 'seal_member_a30_202609_dismissed_at';
  const suppressForMs = 24 * 60 * 60 * 1000;
  let previousFocus = null;
  let timerId = null;

  const dismissedRecently = () => {
    try {
      const dismissedAt = Number(window.localStorage.getItem(storageKey));
      return Number.isFinite(dismissedAt) && Date.now() - dismissedAt < suppressForMs;
    } catch (error) {
      return false;
    }
  };

  const close = () => {
    if (backdrop.hidden) return;
    backdrop.hidden = true;
    document.body.classList.remove('seal-member-campaign-open');
    try { window.localStorage.setItem(storageKey, String(Date.now())); } catch (error) {}
    if (previousFocus) previousFocus.focus();
  };

  const open = () => {
    if (dismissedRecently() || !backdrop.hidden) return;
    previousFocus = document.activeElement;
    backdrop.hidden = false;
    document.body.classList.add('seal-member-campaign-open');
    dialog.focus();
  };

  const onKeydown = (event) => {
    if (event.key === 'Escape') close();
    if (event.key !== 'Tab' || backdrop.hidden) return;
    const focusable = backdrop.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  };

  closeButton.addEventListener('click', close);
  backdrop.addEventListener('click', (event) => { if (event.target === backdrop) close(); });
  document.addEventListener('keydown', onKeydown);

  if (!dismissedRecently()) timerId = window.setTimeout(open, 5000);
  window.addEventListener('pagehide', () => { if (timerId) window.clearTimeout(timerId); }, { once: true });
})();
